/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

import FeathersJSServices from "App/Externals/FeathersJSServices";

const Services = new FeathersJSServices( process.env.CONSOLE_API_ADDRESS || "" );

export {
    Services
};
